import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => {
	return function customUrlButton(args) {
		const { notification, close } = args;
		const url = notification.task().nextCustomUrl();

		return (
			<a className="btn__basic" onClick={() => close()} href={url}>
				<FormattedMessage id={`notification.real-time.${notification.type()}.button.nextTask`} />
			</a>
		);
	};
};
